var responsive_current_width = window.innerWidth;
var responsive_min_width = 992;
// var extra_small_devices = 770;
var responsive_mobile = responsive_current_width < responsive_min_width;
// var responsive_small_devices = responsive_current_width < extra_small_devices;

var scrollpos = window.scrollY;


function swapChildren(obj1, obj2)
{
	var temp = obj2.children().detach();
	obj2.empty().append(obj1.children().detach());
	obj1.append(temp);
}

function toggleMobileStyles()
{
	if (responsive_mobile) {
		$("*[id^='_desktop_']").each(function(idx, el) {
			var target = $('#' + el.id.replace('_desktop_', '_mobile_'));
			if (target.length) {
				swapChildren($(el), target);
			}
		});
		$("body").addClass('mobile');
    } else {
		$("*[id^='_mobile_']").each(function(idx, el) {
			var target = $('#' + el.id.replace('_mobile_', '_desktop_'));
			if (target.length) {
				swapChildren($(el), target);
			}

		});
		$("body").removeClass('mobile');
        $('[data-modal-hide-mobile].is-active').removeClass('is-active');
    }
}

$(window).on('resize', function() {
	var _cw = responsive_current_width;
	var _mw = responsive_min_width;
	var _w = window.innerWidth;
	var _toggle = (_cw >= _mw && _w < _mw) || (_cw < _mw && _w >= _mw);
	responsive_current_width = _w;
    responsive_mobile = responsive_current_width < responsive_min_width;
	if (_toggle) {
		toggleMobileStyles();
	}
	

	// console.log(_cw, _mw, _w);
});

/**
 * Copy code to clipboard
 */
function copyData(containerid) {
	var range = document.createRange();
	range.selectNode(containerid); //changed here
	window.getSelection().removeAllRanges(); 
	window.getSelection().addRange(range); 
	document.execCommand("copy");
	window.getSelection().removeAllRanges();
}

$(document).ready(function() {
	if (responsive_mobile) {
		toggleMobileStyles();
	}

	// Modal dialog open
    $('.open-modal').on('click', function(e) {
        e.preventDefault();
		// $('body').prepend('<div class="body_overlay"></div>');
        $(this).addClass('is-active');
		var modal = $(this).attr('modal');
		// console.log(modal);
		$('body').addClass('modal-open');
		$('body').find('#' + modal).addClass('is-active');
    });

	$('.close-modal').on('click', function(e) {
        e.preventDefault();
		$('.open-modal').removeClass('is-active');
		var modal = $(this).attr('modal');
		$('body').removeClass('modal-open');
		$('body').find('#' + modal).removeClass('is-active');
    });

	$('#copyProductAccessKey').on('click', function(){
		copyData(productAccessKey);
		$(this).text('Skopiowano');
	});

	$('#contentReadKey a').on('click', function(e) {
		e.preventDefault();
		$('body').addClass('modal-open');
		$('body').find('#productKeyModal').addClass('is-active');
	});
});